import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { Context } from "./Context/Context";
import SeoManager from "./seo/SeoManager";

// Shared by the browser (BrowserRouter) and the build-time prerender (StaticRouter).
export function AppShell() {
  return (
    <Context>
      <SeoManager />
      <Suspense fallback={null}>
        <AppRoutes />
      </Suspense>
    </Context>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
